import Vue from "vue"

import dashboard_mixin from "~/mixins/store/dashboard"

export const state = function () {
  return {
    feedback_backup: {},
    decisions: [],
    status_priority: ["Se", "Wa", "Wc", "Fn", "Ex"],
    ...dashboard_mixin.state(),
  }
}

export const mutations = {
  SET_DECISIONS: function (state, decisions) {
    Vue.set(state, "decisions", decisions)
  },
  BACKUP_FEEDBACK: function (state, { feedback, submission }) {
    if (!state.feedback_backup[submission.status])
      state.feedback_backup[submission.status] = {}
    state.feedback_backup[submission.status][submission.id] = feedback
  },
  ...dashboard_mixin.mutations,
}

export const actions = {
  FETCH_DECISIONS: async function ({ commit }) {
    const url = "/influencer/influencer/decisions/"
    const resp = await this.$axios.$get(url)

    commit("SET_DECISIONS", resp)
  },
  ...dashboard_mixin.actions,
}

export const getters = {
  ...dashboard_mixin.getters,
}
